import dayjs from 'dayjs'

/// 将日期格式化为 2021-12-02 18:08:23 这样的格式
function formatTime(dateString) {
    return dayjs(dateString).format('YYYY-MM-DD HH:mm:ss')
}

export function dateTimeRange(n = 7, extendsToDayEnds = true, unit = 'day') {
    const now = dayjs()
    if (extendsToDayEnds) {
        return [
            now.subtract(n, unit).add(1, 'day').startOf('day'), //
            now.endOf('day'),
        ].map(d => d.format('YYYY-MM-DD HH:mm:ss'))
    }
    return [now.subtract(n, unit).add(1, 'day'), now].map(d => d.format('YYYY-MM-DD HH:mm:ss'))
}

/// 日期范围格式化:
///   { [datetimeRangeKey]: [dateBegin, dateEnd] } => { [startKey]: formattedDate, [endKey]: formattedDate }
export function formatDatetimeRange(params, datetimeRangeKey, startKey, endKey) {
    if (Array.isArray(params[datetimeRangeKey]) && params[datetimeRangeKey].length >= 2) {
        params[startKey] = formatTime(params[datetimeRangeKey][0])
        params[endKey] = formatTime(params[datetimeRangeKey][1])
    }
    delete params[datetimeRangeKey]
}

/// 去掉为空('' 或 null) 的字段: { a: 'A', b: null, c: '' } => { a: 'A' }
export function cleanEmptyFields(params) {
    for (const key of Object.keys(params)) {
        if (Object.hasOwnProperty.call(params, key)) {
            if (params[key] === '' || params[key] === null) {
                delete params[key]
            }
        }
    }
    return params
}

/// hack: 使用数据集导出数据时，后台需要必填 beginDate 或 beginDate2, 且beginDate 不会被使用,
/// 所以可以填一个时间，但是格式要正确
/// endDate, endDate2 也一样
export function touchExportParams(params) {
    params.beginDate2 = '2021-09-25 00:00:00'
    params.endDate2 = '2021-09-25 00:00:00'
    return params
}

/// 逗号、空格、换行符分隔的字符串转数组
export function commaSeperatedList(str, { asStr = false } = {}) {
    const r = (str || '')
        .replace('，', ',')
        .replace(/\s+/g, ',')
        .split(/[,，]/)
        .map(no => no.trim())
        .filter(no => no)
    return asStr ? r.join(',') : r
}

/**
 * 创建 使用 router.push 时传递的 query 参数
 * @param {Map<string, string>} params
 * @param {} timeRanges
 * @returns
 */
export function createRouteQuery(from) {
    const _params = {}
    const _timeRanges = []

    const my = {
        params: params => {
            Object.assign(_params, params)
            return my
        },
        param: (key, value) => {
            _params[key] = value
            return my
        },
        timeRange: (key, num, unit = 'day') => {
            _timeRanges.push({ key, num, unit })
            return my
        },
        done: () => {
            return {
                from,
                params: Object.keys(_params)
                    .map(key => `${key}:${_params[key]}`)
                    .join(';'),
                ['time-ranges']: _timeRanges.map(tr => `${tr.key},${tr.num},${tr.unit}`).join(';'),
            }
        },
    }
    return my
}

/**
 * 解析 使用 router.push 时传递的 query 参数
 * @returns - { params: [key, value][], timeRange: [key, TimeRange][] }
 */
export function parseRouteQuery(query, dateTimeExtendsToDayEnds = true) {
    const params = (query.params || '')
        .split(';')
        .filter(p => p)
        .map(p => p.split(':'))

    const timeRanges = (query['time-ranges'] || '')
        .split(';')
        .filter(p => p)
        .map(tr => tr.split(','))
        .map(([k, n, u]) => [k, dateTimeRange(n, dateTimeExtendsToDayEnds, u)])

    return {
        from: query.from,
        params,
        timeRanges,
        get all() {
            return params.concat(timeRanges)
        },
        allAsObject() {
            return params.concat(timeRanges).reduce((acc, [k, v]) => {
                acc[k] = v
                return acc
            }, {})
        },
        patchTo: destObj => {
            for (const [k, v] of params.concat(timeRanges)) {
                destObj[k] = v
            }
        },
    }
}

/**
 * 清空 URL 中 query 值
 */
export function clearRouteQuery(router, route) {
    router.replace({ name: route.name })
}
